angular.module('NaviaqWebApp').directive('layersHistoryPanel', function() {
    'use strict';
    
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'app/main/directives/layers-history-panel.html'
    };
});
